module.exports = __webpack_public_path__ + "img/main.f4f21f0c.png";